// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/******************************************************************************
 *
 *  JournalHub -- Universal Scholarly Publishing 
 *  Copyright (C) 2022 - 2024 Daniel Bingham 
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU Affero General Public License as published
 *  by the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU Affero General Public License for more details.
 *
 *  You should have received a copy of the GNU Affero General Public License
 *  along with this program.  If not, see <https://www.gnu.org/licenses/>.
 *
 ******************************************************************************/
.notification-menu {
    color: var(--header-text-color);
}
.notification-menu .menu-trigger svg {
    color: var(--header-text-color);
    width: 24px;
    height: 24px;
    margin-bottom: -6px;
    padding: 0;
}
.notification-menu .empty-list {
    padding: 10px 20px;
    white-space: nowrap;
    color: black;
}
.notification-menu .notification-trigger {
    position: relative;
    padding: 0 20px;
}
.notification-menu .notification-trigger a:hover {
    filter: none;
}
.notification-menu .notification-trigger .unread-indicator {
    position: absolute;
    top: 2px;
    right: 24px;
    font-size: 10px;
    padding: 2px 4px;

    color: white;

    border-radius: 14px;
    background-color: var(--input-highlight-color);
}
.notification-menu .notification-body {
    max-height: 400px;
    overflow: auto;
    margin-left: -60px;
    top: 52px;
}
.notification-menu .notification-header {
    padding: 0px 10px 5px 10px;
    text-align: right;
    border-bottom: thin solid var(--floating-menu-border-color);
}
.notification-menu .notification-header a:link, 
.notification-menu .notification-header a:active,
.notification-menu .notification-header a:visited {
    color: black; 
    font-size: 12px;
}

`, "",{"version":3,"sources":["webpack://./client/components/notifications/NotificationMenu.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;+EAkB+E;AAC/E;IACI,+BAA+B;AACnC;AACA;IACI,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,eAAe;IACf,gBAAgB;;IAEhB,YAAY;;IAEZ,mBAAmB;IACnB,8CAA8C;AAClD;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,2DAA2D;AAC/D;AACA;;;IAGI,YAAY;IACZ,eAAe;AACnB","sourcesContent":["/******************************************************************************\n *\n *  JournalHub -- Universal Scholarly Publishing \n *  Copyright (C) 2022 - 2024 Daniel Bingham \n *\n *  This program is free software: you can redistribute it and/or modify\n *  it under the terms of the GNU Affero General Public License as published\n *  by the Free Software Foundation, either version 3 of the License, or\n *  (at your option) any later version.\n *\n *  This program is distributed in the hope that it will be useful,\n *  but WITHOUT ANY WARRANTY; without even the implied warranty of\n *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n *  GNU Affero General Public License for more details.\n *\n *  You should have received a copy of the GNU Affero General Public License\n *  along with this program.  If not, see <https://www.gnu.org/licenses/>.\n *\n ******************************************************************************/\n.notification-menu {\n    color: var(--header-text-color);\n}\n.notification-menu .menu-trigger svg {\n    color: var(--header-text-color);\n    width: 24px;\n    height: 24px;\n    margin-bottom: -6px;\n    padding: 0;\n}\n.notification-menu .empty-list {\n    padding: 10px 20px;\n    white-space: nowrap;\n    color: black;\n}\n.notification-menu .notification-trigger {\n    position: relative;\n    padding: 0 20px;\n}\n.notification-menu .notification-trigger a:hover {\n    filter: none;\n}\n.notification-menu .notification-trigger .unread-indicator {\n    position: absolute;\n    top: 2px;\n    right: 24px;\n    font-size: 10px;\n    padding: 2px 4px;\n\n    color: white;\n\n    border-radius: 14px;\n    background-color: var(--input-highlight-color);\n}\n.notification-menu .notification-body {\n    max-height: 400px;\n    overflow: auto;\n    margin-left: -60px;\n    top: 52px;\n}\n.notification-menu .notification-header {\n    padding: 0px 10px 5px 10px;\n    text-align: right;\n    border-bottom: thin solid var(--floating-menu-border-color);\n}\n.notification-menu .notification-header a:link, \n.notification-menu .notification-header a:active,\n.notification-menu .notification-header a:visited {\n    color: black; \n    font-size: 12px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
